export default "__VITE_ASSET__jk6GHrZn__"